import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";

import EmptyTrophiesFigure from "../../assets/images/empty-trophies-figure.png";

import { styles } from "./styles";

const EmptyTrophies = () => {
  const { t } = useTranslation("profiles", { keyPrefix: "trophies" });

  return (
    <Box
      sx={{
        ...styles.container,
        display: "flex",
        flexDirection: "column",
        rowGap: "16px",
        padding: "20px",
      }}
    >
      <Typography
        sx={{
          color: "var(--black-100, #1C1C1C)",
          fontFamily: "Montserrat",
          fontSize: "16px",
          fontStyle: "normal",
          fontWeight: 700,
          lineHeight: "24px",
        }}
      >
        {t("trophies")}
      </Typography>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: "16px",
        }}
      >
        <img src={EmptyTrophiesFigure} alt="empty-trophies-figure" width={73.51} height={73.485} />
        <Typography
          sx={{
            color: "var(--Dark---1000, #111)",
            fontFamily: "Montserrat",
            fontSize: "14px",
            fontStyle: "normal",
            fontWeight: 500,
            lineHeight: "20px",
          }}
        >
          {t("noTrophies")}
        </Typography>
      </Box>
    </Box>
  );
};

export default EmptyTrophies;
